import {Dialog, Modal } from "@mui/material";
import SignUp from "./SignUp";
import FindId from "./FindId";
import FindPassword from "./FindPassword";

const FindPasswordModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <FindPassword onClose={onClose}/>
        </Dialog>
    );
};

export default FindPasswordModal;
